import { render, staticRenderFns } from "./ActiveSessionList.vue?vue&type=template&id=06ba0196&scoped=true&"
import script from "./ActiveSessionList.vue?vue&type=script&lang=js&"
export * from "./ActiveSessionList.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSessionList.vue?vue&type=style&index=0&id=06ba0196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba0196",
  null
  
)

export default component.exports